import React, { forwardRef, memo } from "react";
import PropTypes from "prop-types";
import { InputField } from "./InputField";
import { TextInput } from "./TextInput";
import { useId } from "./useId";
import { Input } from "@fluentui/react-components";

/* eslint-disable-next-line react/display-name */
export const TextInputField = memo(
  forwardRef(({ className, error, description, inputClassName, label, fullWidth, afterInput, ...rest }, ref) => {
    const id = useId();
    const labelId = useId();

    return (
      <InputField
        id={labelId}
        htmlFor={id}
        className={className}
        label={label}
        error={error}
        description={description}
        fullWidth={fullWidth}
      >
        <Input
          id={id}
          ref={ref}
          className={inputClassName}
          appearance="filled-darker"
          contentAfter={afterInput}
          {...rest}
        />
      </InputField>
    );
  })
);

TextInputField.propTypes = {
  className: PropTypes.string,
  label: PropTypes.node,
  error: PropTypes.node,
  description: PropTypes.node,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  fullWidth: PropTypes.bool
};
